import { storeToRefs } from "pinia";

export const useProductTypes = () => {
	const { getProductTypes } = useNorcePwa();
	const { productTypes } = storeToRefs(useNorceStore());

	const fetchProductTypes = async () => {
		let types = productTypes.value;

		if (!types?.length) {
			types = await getProductTypes();
			useNorceStore().setProductTypes(types);
		}

		return types;
	};

	const getProductType = (id?: number) => {
		if (!id) return null;

		return productTypes.value.find((type) => type.Id === id)?.Name || null;
	};

	return { fetchProductTypes, getProductType };
};
